import { Modal, Sizes } from 'react-bootstrap';

import Button from '../form/button';
import React from 'react';

export interface ModalProps {
	show: boolean;
	handleClose: React.ReactEventHandler<{}>;
	className?: string;
	size?: Sizes;
	bodyClass?: string;
	modalTitle?: string;
	modalTitle2?: string;
	dataTestId?: string;
	hideCloseBtn?: boolean;
}

const CustomModal: React.FC<ModalProps> = (props) => {
	return (
		<Modal
			show={props.show}
			onHide={props.handleClose}
			backdrop={true}
			keyboard={true}
			bsSize={props.size}
			className={`${props.className || ''} fadeIn`}
		>
			{props.modalTitle ? (
				<Modal.Header closeButton onHide={props.handleClose}>
					<Modal.Title>
						{props.modalTitle}
						&nbsp;{props.modalTitle2}
					</Modal.Title>
				</Modal.Header>
			) : (
				!props.hideCloseBtn && (
					<Button className="modal-close-btn" btnType="danger" onClick={props.handleClose}>
						<span>×</span>
						<span className="sr-only">Close</span>
					</Button>
				)
			)}
			<Modal.Body className={props.bodyClass}>{props.children}</Modal.Body>
		</Modal>
	);
};

export default CustomModal;
